/** InsCoder WANG.J 2026-08-21 B + Floating product feature nav: sticky anchor navigation with page scroll progress & active state **/
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-float-product-feature]');
  if (!root) return;

  const tabs = Array.from(root.querySelectorAll('.float-product-feature__tab'));
  const progressBar = root.querySelector('[data-progress-bar]');
  const section = root.closest('.float-product-feature-section');

  if (!tabs.length || !progressBar) return;

  // Anchor: the bar stays hidden until the page scrolls past the purchase area
  // (.product-form__buy-buttons or .product-form__qty-buy inside main-product).
  const anchor = document.querySelector(
    '.shopify-section--main-product .product-form__buy-buttons,' +
    ' .shopify-section--main-product .product-form__qty-buy'
  );

  // Resolve the target element of each tab; keep only tabs whose section exists on the page.
  const items = tabs
    .map((tab) => {
      const id = tab.getAttribute('data-feature-id');
      const target = id ? document.getElementById(id) : null;
      return { tab, id, target };
    })
    .filter((item) => item.id && item.target);

  if (!items.length) return;

  // Order the tabs by the DOM position of their target sections (flex order).
  items.forEach((item, index) => {
    item.tab.style.order = index;
  });

  // The horizontal tabs row (used for drag scrolling and for auto-centring the active tab).
  const tabsScroll = root.querySelector('.float-product-feature__tabs');

  const setActive = (index) => {
    items.forEach((item, i) => {
      item.tab.classList.toggle('is-active', i === index);
    });

    // Auto-scroll the active tab into the centre of the visible tabs row so the
    // current feature stays highlighted as the page scrolls.
    if (tabsScroll && items[index] && items[index].tab) {
      const activeTab = items[index].tab;
      const containerRect = tabsScroll.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();
      const targetLeft = tabsScroll.scrollLeft + (tabRect.left - containerRect.left) - (containerRect.width - tabRect.width) / 2;
      tabsScroll.scrollTo({ left: Math.max(targetLeft, 0), behavior: 'smooth' });
    }
  };

  let activeIndex = -1;

  const update = () => {
    const doc = document.documentElement;
    const maxScroll = doc.scrollHeight - window.innerHeight;

    // Whole-page reading progress, updated continuously while scrolling.
    const progress = maxScroll > 0 ? Math.min(Math.max(window.scrollY / maxScroll, 0), 1) : 0;
    progressBar.style.transform = 'scaleX(' + progress + ')';

    // Show the bar once the anchor has been scrolled past; hide it otherwise.
    if (section && anchor) {
      const anchorBottom = anchor.getBoundingClientRect().bottom;
      section.classList.toggle('is-visible', anchorBottom <= 0);
    }

    const navOffset = section ? section.offsetHeight : 0;
    let current = -1;
    items.forEach((item, i) => {
      if (item.target.getBoundingClientRect().top <= navOffset + 1) {
        current = i;
      }
    });
    if (current === -1) {
      current = 0;
    } else if (window.innerHeight + window.scrollY >= doc.scrollHeight - 2) {
      current = items.length - 1;
    }

    if (current !== activeIndex) {
      activeIndex = current;
      setActive(activeIndex);
    }
  };

  // Clicking a tab smooth-scrolls to its target section, offset by the sticky bar height.
  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      const id = tab.getAttribute('data-feature-id');
      const target = id ? document.getElementById(id) : null;
      if (!target) return;

      event.preventDefault();
      const offset = section ? section.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    });
  });

  // Throttle the scroll handler to animation frames so the progress bar stays smooth.
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
});
/** InsCoder WANG.J 2026-08-21 E + Floating product feature nav **/
